import React from "react";
import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";

import { Button } from "../../UI/Button";
import { Grid } from "../../UI/Grid";
import { SuccessButton } from "../SuccessButton";
import { HelpTooltip } from "../HelpTooltip";
import { Checkbox } from "../../UI/Checkbox";
import { Link } from "../Link";
import { URL } from "../../constants/navigation";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";

interface IProps {
  isLoading: boolean;
  isAdminLockIn: boolean;
  isOverrideGenderCheck: boolean;
  toogleAdminLockIn: VoidFunction;
  isNextButtonDisabled: boolean;
  isMatchButtonDisabled: boolean;
  isUsersVisible: boolean;
  isMatchLoading: boolean;
  matchGroups: VoidFunction;
  removeLastAddedGroup: VoidFunction;
  toggleOverrideGenderCheck: VoidFunction;
  setUsersVisible: (bool: boolean) => void;
}

export const RoomOptions: React.FC<IProps> = (props) => {
  const { isAcc } = useSelectedNetworkImportTypes();
  const openGenderSettings = () => window.open(URL.MATCH_RULES, "_blank");

  const handleOnBackClick = props.isUsersVisible
    ? () => props.setUsersVisible(false)
    : props.removeLastAddedGroup;
  const handleSelectNextGroupClick = () => props.setUsersVisible(true);

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Button onClick={handleOnBackClick}>Go Back</Button>
      </Grid>
      <Grid item>
        <Button
          appearance="primary"
          isLoading={props.isLoading}
          onClick={handleSelectNextGroupClick}
          isDisabled={
            props.isNextButtonDisabled ||
            props.isMatchLoading ||
            props.isUsersVisible
          }
        >
          Select Next Group
        </Button>
      </Grid>
      <Grid item>
        <HelpTooltip
          title="Matching Groups"
          text="Residents won't be notified of their new roommate group automatically. To unmatch a user, administrators can visit the user's profile."
        >
          <SuccessButton
            onClick={props.matchGroups}
            isLoading={props.isMatchLoading}
            iconBefore={<CheckCircleOutlineIcon label="Check" />}
            isDisabled={
              props.isLoading ||
              props.isMatchButtonDisabled ||
              props.isUsersVisible
            }
          >
            Match Users As Roommates
          </SuccessButton>
        </HelpTooltip>
      </Grid>
      <Grid item xs={12} mt={2}>
        <Checkbox
          name="lockMatch"
          isChecked={props.isAdminLockIn}
          onChange={props.toogleAdminLockIn}
          label="Lock in this match - users will be unable to leave the match."
          isDisabled={
            props.isLoading ||
            props.isMatchButtonDisabled ||
            props.isUsersVisible
          }
        />
      </Grid>
      {!isAcc && (
        <Grid item xs={12} mt={2}>
          <Checkbox
            name="overrideGenderCheck"
            isChecked={props.isOverrideGenderCheck}
            onChange={props.toggleOverrideGenderCheck}
            label={
              <>
                If this match conflicts with{" "}
                <Link onClick={openGenderSettings}>Gender Settings</Link>,
                override and match these users
              </>
            }
            isDisabled={
              props.isLoading ||
              props.isMatchButtonDisabled ||
              props.isUsersVisible
            }
          />
        </Grid>
      )}
    </Grid>
  );
};
